
export const ANNOUNCEMENTS_MODULE_IDS = {
  ANNOUNCEMENTS_CONTROLLER: Symbol.for('announcementsController'),
  ANNOUNCEMENTS_EVENTS: Symbol.for('announcementsEvents'),
};